import { create } from 'zustand'
import { HighlightEditorStore } from '../types/highlights'
import { validateHighlightData } from '../misc/validateHighlightData'

export const useHighlightEditorStore = create<HighlightEditorStore>((set) => ({
  highlight: undefined,
  setHighlight: (highlight) => set({ highlight }),
  updateHighlight: (highlight) =>
    set((state) => {
      const newHighlightState = { ...state.highlight, ...highlight }
      if (state?.errors?.length > 0) {
        validateHighlightData(newHighlightState, set)
      }
      return { highlight: newHighlightState }
    }),
  setErrors: (errors) => set({ errors }),
  setUploadImageRequired: (required) => set({ uploadImageRequired: required }),
  validateHighlight: (highlight) => validateHighlightData(highlight, set),
}))
